import { Button, Row } from 'antd';
import { useNavigate } from 'react-router-dom';

import { Arrow } from '../../../Common/Icon';

import styles from './index.module.scss';

function JoinOurCommunity() {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.backgroundImage}></div>
      <div className={styles.content}>
        <h2 className={styles.title}>
          Join our{' '}
          <span className={styles.highlighted}>international community</span>{' '}
          where people from all countries{' '}
          <span className={styles.highlighted}> share how much they tip </span>{' '}
          at restaurants.
        </h2>

        <Row justify="center">
          <Button
            size="large"
            type="primary"
            icon={<Arrow />}
            className={styles.button}
            onClick={() => navigate('/international')}
          >
            Go To International Community
          </Button>
        </Row>
      </div>
    </div>
  );
}

export default JoinOurCommunity;
